import { render } from "./PpcProducts.vue?vue&type=template&id=9e962088&scoped=true"
import script from "./PpcProducts.vue?vue&type=script&lang=js"
export * from "./PpcProducts.vue?vue&type=script&lang=js"

import "./PpcProducts.vue?vue&type=style&index=0&id=9e962088&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e962088"]])

export default __exports__